import { handleActions } from 'redux-actions';
import Immutable from 'immutable';
import { types as httpActionTypes } from 'actions/httpActions/httpActions';

export default handleActions({
  [httpActionTypes.REQUEST_MADE]: (state, action) => state.setIn([action.requestName, 'isInFlight'], true),
  [httpActionTypes.REQUEST_SUCCESS]: (state, action) => state
    .setIn([action.requestName, 'isInFlight'], false)
    .setIn([action.requestName, 'isError'], false)
    .setIn([action.requestName, 'retries'], 0),
  [httpActionTypes.REQUEST_ERROR]: (state, action) => state
    .setIn([action.requestName, 'isError'], true)
    .setIn([action.requestName, 'isInFlight'], false),
  [httpActionTypes.REQUEST_RETRY]: (state, action) => {
    const retries = state.getIn([action.requestName, 'retries'], 0);
    return state.setIn([action.requestName, 'retries'], retries + 1);
  },
}, Immutable.Map());



// WEBPACK FOOTER //
// ./reducers/httpReducers/httpReducers.js